import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { QuickLinks } from "./quick_links";
//
// NOTE: Left a few things out from VBP/Frontend/AanZet/custom_components/components/submenu_block.tsx to do a quick estimate.
// These may need to be reconsidered when doing a proper implementation.
//
export class SubMenuBlock extends React.Component {
    componentDidMount() {
        this.scrollToGroupByCurrentHash();
        window.addEventListener("hashchange", ()=>this.scrollToGroupByCurrentHash());
    }
    scrollToGroupByCurrentHash() {
        this.scrollToGroup(window.location.hash.substring(1));
    }
    scrollToGroup(slug) {
        const element = document.querySelector(`[data-anchor="${slug}"]`);
        if (!element) return;
        element.scrollIntoView({
            behavior: "smooth"
        });
    }
    render() {
        const { title, text, links } = this.props;
        return /*#__PURE__*/ _jsxs("section", {
            className: "block block--knowledge-bank container--full gutter--m align--center",
            children: [
                title && /*#__PURE__*/ _jsx("header", {
                    className: "block__header",
                    children: title && /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l",
                        children: title
                    })
                }),
                /*#__PURE__*/ _jsx(QuickLinks, {
                    title: text,
                    links: links,
                    handleScroll: (slug)=>this.scrollToGroup(slug)
                })
            ]
        });
    }
}
